import { openAppPage } from "./callHandler";
import { sources } from "./index";
import url from "./url";
var newCarLinks = url.newCarLinks,
  usedCarLinks = url.usedCarLinks;
// 共用方法
export function superLinks(params) {
  var touch = params.touch,
    desktop = params.desktop;
  switch (sources.os) {
    case "touch":
      if (typeof touch === "function") {
        touch();
      } else if (touch) {
        window.location.href = touch;
      }
      break;
    case "PC":
      if (typeof desktop === "function") {
        desktop();
      } else if (desktop) {
        window.open(desktop);
      }
      break;
    case "iOS":
      openAppPage({
        link: params.iOS || params.app
      });
      break;
    case "Android":
      openAppPage({
        link: params.android || params.app
      });
      break;
    default:
      console.log("不存在设备");
  }
}
var newCar = function newCar(bridage, params) {
  var urls = newCarLinks[bridage](params);
  superLinks(urls);
};
var usedCar = function usedCar(bridage, params) {
  var urls = usedCarLinks[bridage](params);
  superLinks(urls);
};
superLinks.newCar = newCar;
superLinks.usedCar = usedCar;